// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__YhdaV","actions":"GroupTable_actions__q5WwG","deleteModalFooter":"GroupTable_deleteModalFooter__2vtge"};